export default __webpack_public_path__ + "static/media/poppy_carousel_4.png.webp";